import {Navigate} from "react-router-dom";
import {useAuthState} from 'react-firebase-hooks/auth';
import React from "react";
import DashboardLayout from "./layouts/dashboard";
import {firebaseAuth} from "./App";

export default function AuthenticatedApp() {
    const [user, loading, error] = useAuthState(firebaseAuth);

    if (loading) {
        return <div></div>;
    }

    if (error) {
        // Handle auth error
        return <div>Error: {error.message}</div>;
    }

    if (!user) {
        // Not logged in, redirect to login
        return <Navigate to='/login' />;
    }

    // User is logged in, render the Dashboard.
    // The Dashboard will now be responsible for fetching its own data.
    return <DashboardLayout user={user} />;
}